import { createAuthStore } from './composables/useAuth';

require('./bootstrap');

import { createApp } from 'vue';
import App from './views/App';
import router from './router';
import './validators';

/**
 * jsPDF関連のインポートと設定
 */
import 'jspdf-autotable';

const authStore = createAuthStore();

const app = createApp({});

app.component('App', App).use(authStore).use(router).mount('#app');
